const translations = {
    fr: {
      loading: "Chargement en cours..."
    },
    en: {
      loading: "Loading..."
    },
    de: {
      loading: "Wird geladen..."
    },
    es: {
      loading: "Cargando..."
    },
    it: {
      loading: "Caricamento in corso..."
    }
  };
  
  export default translations;
  